<div class="container"  >
  <h1 class="page-title"><span class="icon"><i class="fas fa-truck-moving"></i></span>{{ 'RFQPreview.Header' | translate }}</h1>

  <p-card>

      <div class="p-fluid formgrid grid">

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.RFQNum' | translate }}</label>
          <div class="item">
            {{ rfqData?.seqNo }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label  class="col column-label">{{ 'RFQPreview.MainTable.Forwarder' | translate }}</label>
          <div class="item">
            {{ rfqData?.forwarder | optionsMapping : bookingForwarderOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label class="col column-label" >{{ 'RFQPreview.MainTable.Status' | translate }}</label>
          <div class="item">
           {{ rfqData?.status | optionsMapping : rfqStatusOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label class="column-label" >{{ 'RFQPreview.MainTable.OriginCountry' | translate }}</label>
          <div class="item">
            {{ rfqData?.fromCountry | optionsMapping:countryOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label class="column-label" >{{ 'RFQPreview.MainTable.OriginCity' | translate }}</label>
          <div class="item">
            {{ rfqData?.fromCity | optionsMapping:allCityOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label class="column-label" >{{ 'RFQPreview.MainTable.OriginArea' | translate }}</label>
          <div class="item">
            {{ rfqData?.fromArea | optionsMapping:allAreaOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label class="column-label" >{{ 'RFQPreview.MainTable.OriginCourierCity' | translate }}</label>
          <div class="item">
            {{ rfqData?.expressFromArea }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label class="column-label" >{{ 'RFQPreview.MainTable.DestinationFromCountry' | translate }}</label>
          <div class="item">
            {{ rfqData?.toCountry | optionsMapping:countryOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.DestinationCity' | translate }}</label>
          <div class="item">
            {{ rfqData?.toCity | optionsMapping:allCityOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.DestinationArea' | translate }}</label>
          <div class="item">
            {{ rfqData?.toArea | optionsMapping:allAreaOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label class="column-label" >{{ 'RFQPreview.MainTable.DestinationCourierCity' | translate }}</label>
          <div class="item">
            {{ rfqData?.expressToArea }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.AccountingCurrency' | translate }}</label>
          <div class="item">
            {{ rfqData?.currency | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.DocumentType' | translate }}</label>
          <div class="item">
            {{ rfqData?.rfqCategory | optionsMapping:rfqCategoryTypeOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.PickUpAddress' | translate }}</label>
          <div class="item">
            {{ rfqData?.awbAddress | optionsMapping:pickupLocationOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.CourierDeliveryCondition' | translate }}</label>
          <div class="item">
            {{ rfqData?.expressTerm | optionsMapping:expressTermOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.Customer' | translate }}</label>
          <div class="item">
            {{ rfqData?.consigneekey | replaceNullWith:'-' }}
            {{ rfqData?.consigneeName | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.ShippingType' | translate }}</label>
          <div class="item">
            {{ rfqData?.shippingType | optionsMapping:shippingTypeOptions | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.EffectiveDate' | translate }}</label>
          <div class="formgrid grid">
            <div class="col">
              {{ rfqData?.effectStartDate |  date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone  | replaceNullWith:'-' }} -
              {{ rfqData?.effectEndDate |  date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone  | replaceNullWith:'-' }}
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.Effective' | translate }}</label>
          <div class="item">
            {{ rfqData?.isActivated | optionsMapping: yesNoOption | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.Remarks' | translate }}</label>
          <div class="item">
            <textarea pInputTextarea  [(ngModel)]="headerRemark"
            [rows]="3"></textarea>
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.OutsourcingCompany' | translate }}</label>
          <div class="item">
            {{ rfqData?.outsourcingCompany | replaceNullWith:'-' }}
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.Facility' | translate }}</label>
          <div class="item">
            {{ rfqData?.facility }}
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.IsConsolidation' | translate }}</label>
          <div class="item">
            {{ rfqData?.isConsolidation | replaceNullWith:'-' }}
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.Creator' | translate }}</label>
          <div class="item">
            {{ rfqData?.createUser | replaceNullWith:'-' }}
          </div>
        </div>


        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.CreationTime' | translate }}</label>
          <div class="item">
            {{ rfqData?.createDt   | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone  }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.UpdateBy' | translate }}</label>
          <div class="item">
            {{ rfqData?.updateUser }}
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-3 mb-3">
          <label>{{ 'RFQPreview.MainTable.EditTime' | translate }}</label>
          <div class="item">
            {{ rfqData?.updateDt  | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone  }}
          </div>
        </div>
      </div>

      <p-table #DODataTable  dataKey="seqNo"  [autoLayout]="true"
            [value]="rfqDetail" [columns]="detailColumns" [paginator]="false" class="datatable" >

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [pSortableColumn]="col.field" *ngFor="let col of columns" pResizableColumn pReorderableColumn>
              {{ col.header | translate }}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <td *ngFor="let col of columns">
              <div [ngSwitch]="col.field">

                <ng-container *ngSwitchCase="'feeType'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: feeTypeOptions   }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'incoTerm'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: shipTermOptions   }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'shippingSectionDesc'">
                  <div class="overflow-text">
                    {{ rowData[col.field] }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'currency'">
                  <div class="overflow-text">
                    {{ rowData[col.field]  }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'unitPrice'">
                  <div class="overflow-text">
                    {{ rowData[col.field]  }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'calculationUnit'">
                  <div class="overflow-text">
                    {{ rowData[col.field]  | optionsMapping: calculationUnitOptions  }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'intervalUnitStart'">
                  <div class="overflow-text">
                    {{ rowData[col.field] }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'intervalUnitEnd'">
                  <div class="overflow-text">
                    {{ rowData[col.field] }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'minimalCharge'">
                  <div class="overflow-text">
                    {{ rowData[col.field] }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'remark'">
                  <input pInputText type="text" [(ngModel)]="rowData[col.field]" >
                </ng-container>

                <ng-container *ngSwitchCase="'isTieredGroup'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: yesNoOption  }}
                  </div>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="grid">
        <div class="col">
            <button pButton pRipple label="{{ 'RFQPreview.SubTable.Edit' | translate }}" (click)="editBtn()" [disabled]="disableEditBtn" ></button>
            <button pButton pRipple class="ml-2 p-button-warning" label="{{ 'RFQPreview.SubTable.UpdateRemark' | translate }}" (click)="updateRemarkBtn()" [disabled]="!isCanEditRemark" ></button>
        </div>
      </div>
  </p-card>


</div>

